import axios from "axios";
import { IMAGE_BUCKET_URL, POINTS_URL, REDEEM_POINTS, REDEEM_DATES, LOYALTY_CATEGORY_URL } from "../../../DataStore/ApiConstant";
import { useEffect,useState } from "react";
import TranslatesContent from "../../../DataStore/Languages/translatesContent";
import OdometerDisplay from '../Loyalty/odometer';
import Odometer from 'react-odometerjs';
import { useRedeemDates } from "../../../services/cashier";
import { formatDateToDesiredFormat } from "../../../utils";
import { connect } from "react-redux";
import { fetchLoyaltyUser } from "../../../DataStore/LoyaltyUser/LoyaltyUserActions";
var moment = require("moment")

const FALLBACK_LOYALTY_CATEGORIES = [
  { cat_id: 1, category_name: "Bronze", range_start: 0, range_end: 9999, logo: "1.png" },
  { cat_id: 2, category_name: "Silver", range_start: 10000, range_end: 149999, logo: "2.png" },
  { cat_id: 3, category_name: "Gold", range_start: 150000, range_end: 299999, logo: "3.png" },
  { cat_id: 4, category_name: "Platinum", range_start: 300000, range_end: 499999, logo: "4.png" },
  { cat_id: 5, category_name: "Legend", range_start: 500000, range_end: 2000000, logo: "5.png" },
];

const TEST_LOYALTY_USER_DATA = [
  {
    next_cat_pr: 40,
    loyal_points: 4000,
    cat_id: 1,
    category_name: "Bronze",
    range_start: 0,
    range_end: 99,
    logo: "1.png",
    color: "#ff9d42",
  },
];

const LoyaltyContent = ({ openPopup, login, loyaltyUser, fetchLoyaltyUserData, userData }) => {

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  console.log(startDate);
  console.log(endDate);
  
  const [value, setValue] = useState(0);
  const [value2, setValue2] = useState(0);
  const [loyaltyCategories, setLoyaltyCategories] = useState([]);

  const [errmsg, setErrmsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [redeemStatus, setRedeemStatus] = useState(null);
  let points = 0 

  const createParticles = () => {
    const container = document.getElementById("particles");
    const particleCount = 20;

    if (!container) {
      return;
    }

    container.innerHTML = "";

    for (let i = 0; i < particleCount; i += 1) {
      const particle = document.createElement("span");
      particle.className = "particle";
      particle.style.left = `${Math.random() * 100}%`;
      particle.style.top = `${Math.random() * 100}%`;
      particle.style.width = `${Math.random() * 4 + 2}px`;
      particle.style.height = particle.style.width;
      particle.style.animationDelay = `${Math.random() * 2.5}s`;
      particle.style.animationDuration = `${Math.random() * 2 + 2}s`;
      container.appendChild(particle);
    }
  };

  const fetchPoints = (startDate, endDate) => {
    axios
      .get(POINTS_URL + `?startdate=${startDate}&enddate=${endDate}`)
      .then((resp) => {
        console.log(resp?.data?.points);
        if (resp?.data?.points > 0) {
          const points = Math.floor(resp?.data?.points);
          setValue(points);
          setValue2(Math.floor(points / 2000));
        } else {
          console.error('Points data is not available');
        }
      })
      .catch((err) => {
        console.error('Error fetching points', err);
      });
  };

  const fetchLoyaltyCategories = async () => {
    try {
      const response = await axios.get(LOYALTY_CATEGORY_URL);
      const rawCategories = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

      const categories = [...rawCategories].sort(
        (left, right) => Number(left?.cat_id) - Number(right?.cat_id)
      );

      setLoyaltyCategories(categories);
    } catch (err) {
      console.error("Error fetching loyalty categories", err);
    }
  };

  useEffect(() => {
    fetchLoyaltyCategories();

    if (login) {
      fetchLoyaltyUserData();
    }

    createParticles();

  }, [login, fetchLoyaltyUserData]);

  const rawLoyaltyPayload = loyaltyUser?.data?.data ?? loyaltyUser?.data ?? loyaltyUser ?? TEST_LOYALTY_USER_DATA;
  // const rawLoyaltyPayload =  TEST_LOYALTY_USER_DATA;
  const userLoyalty = Array.isArray(rawLoyaltyPayload)
    ? (rawLoyaltyPayload[0] || {})
    : rawLoyaltyPayload;
  const userDta = userData?.data?.data1;
  const userSession = userData?.data?.session;
  console.log(userSession?.mid);
  
  const displayUserName =
    userSession?.mid || "-";

  const resolvedCategories = loyaltyCategories.length > 0
    ? loyaltyCategories
    : FALLBACK_LOYALTY_CATEGORIES;

  const currentPoints = Number(userLoyalty?.loyal_points ?? userLoyalty?.points ?? 0);
  const progressPercent = Number.isFinite(Number(userLoyalty?.next_cat_pr))
    ? Math.max(0, Math.min(100, Number(userLoyalty?.next_cat_pr)))
    : 0;
  const currentTier = resolvedCategories.find(
    (item) => Number(item?.cat_id) === Number(userLoyalty?.cat_id)
  ) || resolvedCategories.find((item) => {
    const rangeStart = Number(item?.range_start);
    const rangeEnd = Number(item?.range_end);
    const isHighestTier = Number(item?.cat_id) === Number(resolvedCategories[resolvedCategories.length - 1]?.cat_id);

    if (Number.isNaN(rangeStart) || Number.isNaN(rangeEnd)) {
      return false;
    }

    return isHighestTier ? currentPoints >= rangeStart : currentPoints >= rangeStart && currentPoints <= rangeEnd;
  }) || resolvedCategories.find(
    (item) => (item?.category_name || "").toLowerCase() === (userLoyalty?.category_name || "").toLowerCase()
  );
  const currentTierName = currentTier?.category_name || userLoyalty?.category_name || "-";
  const nextTierTargetPoints = Number(currentTier?.range_end ?? userLoyalty?.range_end ?? 0);
  const currentTierIndex = resolvedCategories.findIndex(
    (item) => Number(item?.cat_id) === Number(currentTier?.cat_id)
  );
  const nextTier = currentTierIndex >= 0 ? resolvedCategories[currentTierIndex + 1] : undefined;
  const nextTierDisplay = currentTierName.toLowerCase() === "legend" ? "*****" : (nextTier?.category_name || "-");
  const currentBadgeLogo = userLoyalty?.logo || currentTier?.logo || "bronze.svg";

  const getBadgeClassName = (categoryName) => {
    const normalized = (categoryName || "").toLowerCase();

    if (normalized === "bronze") return "badge-bronze";
    if (normalized === "silver") return "badge-silver";
    if (normalized === "gold") return "badge-star";
    if (normalized === "platinum") return "badge-platinum";
    if (normalized === "legend") return "badge-gold";

    return "";
  };

  useEffect(() => {

    const progressBar = document.getElementById("loyaltyProgressBar");

    if (!progressBar) {
      return undefined;
    }

    const timer = setTimeout(() => {
      progressBar.style.width = `${progressPercent}%`;
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [progressPercent]);
  
  
  
  return (
    <>
     <>
  <div
    className="container my-5"
    style={{ maxWidth: 1000, background: "var(--bg-gradient)" }}
  >
    <div className="card premium-dashboard-card border-0 p-4 p-md-5">
      <div className="row g-4 align-items-center flex-column-reverse flex-md-row">
        <div className="col-12 col-md-8 text-center text-md-start">
          <span
            className="text-uppercase tracking-wider text-muted small d-block mb-1"
            style={{ letterSpacing: 3 }}
          >
            <TranslatesContent contentKey="loyalty-status-in-loyalty" />
          </span>
          <h1 className="username-text display-4 mb-2">{displayUserName}</h1>
          {/* <div className="cyan-status small d-flex align-items-center justify-content-center justify-content-md-start gap-2 mb-4">
            <span
              className="d-inline-block rounded-circle bg-info"
              style={{ width: 8, height: 8, boxShadow: "0 0 10px #00f2fe" }}
            />
            {progressPercent}% <TranslatesContent contentKey="progress-to-next-level-in-loyalty" />
          </div> */}
          <div className="w-100">
            <div
              className="d-flex justify-content-between text-uppercase small text-secondary mb-2"
              style={{ letterSpacing: 1 }}
            >
              <span>
                <TranslatesContent contentKey="current-tier-in-loyalty" />: <strong className="text-white">{currentTierName}</strong>
              </span>
              <span style={{ color: "#f1c40f", fontWeight: 600 }}>
                <TranslatesContent contentKey="next" />: {nextTierDisplay}
              </span>
            </div>
            <div className="progress custom-progress-track">
              <div
                className="progress-bar custom-progress-bar"
                id="loyaltyProgressBar"
                data-progress={progressPercent}
                role="progressbar"
                aria-valuenow={progressPercent}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
            <div className="d-flex justify-content-between text-muted small mt-2">
              <span>
                <strong className="text-white">{currentPoints}</strong> <TranslatesContent contentKey="points_in_loyalty" />
              </span>
              <span>
                <strong className="text-white">{nextTierTargetPoints}</strong> <TranslatesContent contentKey="points_in_loyalty" />
              </span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 d-flex justify-content-center">
          <div className="badge-circle" id="badgeContainer">
            <div className="particles-container" id="particles" />
            <div className="col-9 text-center">
              <div className="">
                <img
                  src={`${IMAGE_BUCKET_URL}${currentBadgeLogo}`}
                  className="img-fluid w-100"
                  alt={currentTierName}
                />
              </div>
            </div>
            <div className="badge-label" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="container  text-center">
    <div className="row g-4 text-start d-flex justify-content-between  mt-4">
      <div className="row">
        <div className="col-12 text-center text-lg-start text-md-start tourDetailsTitel">
          <div className=" text-center" style={{fontSize: "2.5rem"}}><TranslatesContent contentKey="ballysbet-loyalty-program-in-loyalty" /></div>
          {/* <h2>“The First-Ever BallysBet Online Championship”</h2> */}
        </div>
      </div>
      {resolvedCategories.map((category) => {
        const isHighestTier = Number(category?.cat_id) === Number(resolvedCategories[resolvedCategories.length - 1]?.cat_id);
        const rangeText = isHighestTier
          ? `${category?.range_start} and above`
          : `${category?.range_start} - ${category?.range_end}`;

        return (
          <div className="col" key={category?.cat_id}>
            <div className="vip-card">
              <div className="row">
                <div className="col-12 mb-3">
                  <img
                    src={`${IMAGE_BUCKET_URL}${category?.logo}`}
                    className="img-fluid"
                    alt={category?.category_name || ""}
                  />
                </div>
              </div>
              <span className={`badge-custom ${getBadgeClassName(category?.category_name)}`}>
                {category?.category_name}
              </span>
              <div className="wager-amount">{rangeText}</div>
              <div className="wager-label"><TranslatesContent contentKey="wager-points-in-loyalty" /></div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</>

      
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loyaltyUser: state.LoyaltyUser?.data || null,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLoyaltyUserData: () => dispatch(fetchLoyaltyUser()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyContent);
